import loadable from '@loadable/component';

export const User = loadable(
  /* #__LOADABLE__ */ () => import(/* webpackChunkName: "AssignedLearningLearnerPage" */ './User'),
);
